import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './locales/i18n';
import { projectConfig } from './config/projectConfig';
import { ThemeModeProvider } from './theme/ThemeModeProvider';

// Set dynamic document title and meta tags
document.title = projectConfig.branding.title;
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute('content', projectConfig.branding.metaDescription);
}
const themeColor = document.querySelector('meta[name="theme-color"]');
if (themeColor) {
  themeColor.setAttribute('content', projectConfig.theme.colors.primary.main);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeModeProvider>
          <App />
        </ThemeModeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
